import { useMemo, useState } from "react";
import classNames from "./TryDomainTranslation.module.css";

const domains = [
  {
    name: "Manufacturing",
    en: [
      "Die casting",
      "Extrusion",
      "Annealing",
      "Work hardening",
      "Tolerance stack-up",
      "Friction welding",
      "Powder metallurgy",
      "Electroplating",
      "Additive manufacturing",
      "Cnc machining",
      "Plasma cutting",
      "Induction hardening",
      "Hydroforming",
      "Spin forming",
      "Shot peening",
      "Sintering",
      "Brazing",
      "Jig boring",
      "Reshoring",
      "Process capability index",
      "Total productive maintenance",
      "Lean six sigma",
      "Kaizen",
      "Kanban",
      "Gemba walk",
      "5s methodology",
      "Root cause analysis",
      "Failure mode and effects analysis",
      "Statistical process control",
      "Just-in-time production",
      "Poka-yoke",
      "Andon system",
      "Overall equipment effectiveness",
      "Gage repeatability and reproducibility",
      "First article inspection",
      "Reflow soldering",
      "Incremental sheet forming",
      "Multi-spindle drilling",
      "Electrochemical machining",
      "Superplastic forming",
      "Cold heading",
      "Ultrasonic welding",
      "Non-destructive testing",
      "Dielectric heating",
      "Forging flash",
      "Hob cutting",
      "Subtractive manufacturing",
      "Laser ablation",
      "Reverse engineering",
      "Tribology",
    ],
    "zh-Hans": [
      "压铸",
      "挤压",
      "退火",
      "加工硬化",
      "公差累积",
      "摩擦焊接",
      "粉末冶金",
      "电镀",
      "增材制造",
      "数控加工",
      "等离子切割",
      "感应淬火",
      "水胀成形",
      "旋压成形",
      "喷丸",
      "烧结",
      "钎焊",
      "镗孔",
      "回流制造",
      "过程能力指数",
      "全面生产维护",
      "精益六西格玛",
      "改善",
      "看板",
      "现场巡视",
      "5S 方法论",
      "根本原因分析",
      "失效模式及影响分析",
      "统计过程控制",
      "准时生产",
      "防呆设计",
      "安灯系统",
      "设备综合效率",
      "量具重复性与再现性",
      "首件检验",
      "回流焊",
      "增量板材成形",
      "多轴钻孔",
      "电化学加工",
      "超塑性成形",
      "冷镦",
      "超声焊接",
      "无损检测",
      "介电加热",
      "锻造飞边",
      "滚刀切割",
      "减材制造",
      "激光烧蚀",
      "逆向工程",
      "摩擦学",
    ],
  },
  {
    name: "Technology",
    en: [
      "Edge computing",
      "Quantum entanglement",
      "Homomorphic encryption",
      "Neural radiance fields",
      "Zero-knowledge proofs",
      "Multi-factor authentication",
      "Digital twin",
      "Federated learning",
      "Graph database",
      "Automated reasoning",
      "Sharding",
      "Side channel attack",
      "Self-healing networks",
      "Memory hard functions",
      "Virtual memory paging",
      "Heterogeneous computing",
      "Container orchestration",
      "Dynamic binary translation",
      "Predictive maintenance",
      "Blockchain consensus mechanism",
      "Synthetic data",
      "Secure enclave",
      "Data sovereignty",
      "Software-defined networking",
      "Chaos engineering",
      "Immutable ledger",
      "Homogeneous clustering",
      "Adversarial machine learning",
      "End-to-end encryption",
      "Hardware root of trust",
      "Knowledge distillation",
      "Polyglot persistence",
      "Quantum key distribution",
      "Serverless computing",
      "Automated penetration testing",
      "Fuzzy logic",
      "Cap theorem",
      "Event-driven architecture",
      "Non-volatile memory express",
      "Webassembly",
      "Isomorphic javascript",
      "Elliptic curve cryptography",
      "Dark pattern design",
      "Differential privacy",
      "Geofencing",
      "Human augmentation",
      "Energy harvesting",
      "Digital rights management",
      "Data mesh",
      "Computational photography",
      "Tensor processing unit",
    ],
    "zh-Hans": [
      "边缘计算",
      "量子纠缠",
      "同态加密",
      "神经辐射场",
      "零知识证明",
      "多因素认证",
      "数字孪生",
      "联邦学习",
      "图数据库",
      "自动推理",
      "分片",
      "旁路攻击",
      "自愈网络",
      "内存硬函数",
      "虚拟内存分页",
      "异构计算",
      "容器编排",
      "动态二进制翻译",
      "预测性维护",
      "区块链共识机制",
      "合成数据",
      "安全飞地",
      "数据主权",
      "软件定义网络",
      "混沌工程",
      "不可变分类账",
      "同质化集群",
      "对抗性机器学习",
      "端到端加密",
      "硬件信任根",
      "知识蒸馏",
      "多语言持久性",
      "量子密钥分发",
      "无服务器计算",
      "自动渗透测试",
      "模糊逻辑",
      "CAP 定理",
      "事件驱动架构",
      "非易失性存储快递",
      "WebAssembly",
      "同构 JavaScript",
      "椭圆曲线加密",
      "暗黑模式设计",
      "差分隐私",
      "地理围栏",
      "人机增强",
      "能量采集",
      "数字版权管理",
      "数据网格",
      "计算摄影",
      "张量处理单元",
    ],
  },
  {
    name: "Transportation",
    en: [
      "Intermodal freight",
      "Waybill",
      "Ballastless track",
      "Aerodynamic drag",
      "Cabotage",
      "Pantograph",
      "Deadheading",
      "Load factor",
      "Jet bridge",
      "Airfoil",
      "Road diet",
      "High-speed maglev",
      "Catenary system",
      "Turnpike tolling",
      "Tractive effort",
      "Marshalling yard",
      "Positive train control",
      "Cold chain logistics",
      "Tare weight",
      "Containerization",
      "Dwell time",
      "Slot management",
      "Cab signaling",
      "Pavement fatigue",
      "Reverse logistics",
      "Tramway infrastructure",
      "Headway",
      "Runway excursion",
      "Wheel-rail interaction",
      "Dead reckoning",
      "Transport demand modeling",
      "Urban freight distribution",
      "Paratransit",
      "Bus rapid transit",
      "Straddle carrier",
      "Emission control area",
      "Automated people mover",
      "Trolleybus system",
      "Dynamic routing",
      "Overhead contact system",
      "Airside operations",
      "Wayfinding signage",
      "Last-mile delivery",
      "Tandem axle",
      "Drayage",
      "Spur track",
      "Helical gearbox",
      "Turbofan bypass ratio",
      "Gradient resistance",
      "Canal lock system",
      "Aerotropolis",
    ],
    "zh-Hans": [
      "联运货运",
      "运单",
      "无碴轨道",
      "空气动力阻力",
      "沿海航运",
      "受电弓",
      "空驶",
      "载客率",
      "登机廊桥",
      "翼型",
      "道路缩减",
      "高速磁悬浮",
      "接触网系统",
      "收费公路",
      "牵引力",
      "编组站",
      "列车自动控制",
      "冷链物流",
      "自重",
      "集装箱化",
      "停留时间",
      "时隙管理",
      "驾驶室信号",
      "路面疲劳",
      "逆向物流",
      "有轨电车基础设施",
      "列车间隔",
      "跑道偏离",
      "轮轨相互作用",
      "航位推算",
      "运输需求建模",
      "城市货运配送",
      "辅助交通",
      "快速公交",
      "跨运车",
      "排放控制区",
      "自动旅客运输系统",
      "无轨电车系统",
      "动态调度",
      "架空接触系统",
      "空侧运营",
      "导向标识",
      "最后一英里配送",
      "双轴桥",
      "短途货运",
      "支线轨道",
      "螺旋齿轮箱",
      "涡扇旁通比",
      "坡度阻力",
      "船闸系统",
      "空港都市",
    ],
  },
  {
    name: "Church",
    en: [
      "Ecumenism",
      "Eschatology",
      "Catechesis",
      "Vestments",
      "Chancel",
      "Apologetics",
      "Cenobitic monasticism",
      "Iconostasis",
      "Anathema",
      "Sacramental wine",
      "Lectio divina",
      "Exegesis",
      "Ablution",
      "Chrismation",
      "Hagiography",
      "Mystagogy",
      "Transubstantiation",
      "Cantillation",
      "Gregorian chant",
      "Liturgical calendar",
      "Kyrie eleison",
      "Pentecostalism",
      "Pulpit supply",
      "Benediction",
      "Hermeneutics",
      "Eucharistic adoration",
      "Monstrance",
      "Concelebration",
      "Prevenient grace",
      "Sanctification",
      "Apostolic succession",
      "Diaconate",
      "Church polity",
      "Presbyterianism",
      "Anabaptism",
      "Ordo salutis",
      "Vestibule theology",
      "Sacrificial lamb",
      "Cistercian order",
      "Triduum",
      "Consubstantiation",
      "Homiletics",
      "Orthodoxy",
      "Pastoral epistles",
      "Iconoclasm",
      "Theophany",
      "Inculturation",
      "Pneumatology",
      "Sola scriptura",
      "Sanctuary lamp",
      "Epiclesis",
    ],
    "zh-Hans": [
      "普世教会运动",
      "末世论",
      "教理问答",
      "圣衣",
      "圣坛区",
      "护教学",
      "修道院生活",
      "圣像屏",
      "绝罚",
      "圣餐酒",
      "神圣阅读",
      "释经学",
      "净礼",
      "傅油礼",
      "圣人传记",
      "奥秘学",
      "圣体变质",
      "圣咏诵读",
      "格里高利圣咏",
      "礼仪年历",
      "主怜悯",
      "五旬宗",
      "讲坛供应",
      "祝福仪式",
      "经学解释",
      "圣体崇拜",
      "圣体容器",
      "共祭",
      "预存恩典",
      "成圣",
      "使徒继承",
      "执事职务",
      "教会治理",
      "长老会制",
      "再洗礼派",
      "救赎次序",
      "前厅神学",
      "献祭羔羊",
      "熙笃会",
      "三日节",
      "并存论",
      "讲道学",
      "正统信仰",
      "牧函",
      "圣像破坏运动",
      "显现节",
      "文化适应",
      "圣灵学",
      "唯独圣经",
      "圣灯",
      "降临祷文",
    ],
  },
  {
    name: "Pharmaceutical",
    en: [
      "Biopharmaceutics",
      "Pharmacokinetics",
      "Lipophilicity",
      "Excipient",
      "Prodrug",
      "Bioavailability",
      "Microsomal enzymes",
      "Chirality",
      "Enantiomer",
      "Therapeutic index",
      "Half-Life Elimination",
      "First-Pass metabolism",
      "Allosteric modulation",
      "Ligand binding affinity",
      "Receptor agonist",
      "Pharmacodynamics",
      "Orphan drug designation",
      "Narrow therapeutic index",
      "Biotransformation",
      "Enteric coating",
      "Nanocarrier",
      "Polypharmacy",
      "Pharmacovigilance",
      "Cytotoxic agent",
      "Compounded medication",
      "Drug Master file",
      "Oral bioavailability",
      "Adenosine triphosphate-binding cassette",
      "Efflux transporter",
      "Parenteral administration",
      "Sterile filtration",
      "Hydrophilic-lipophilic balance",
      "Active pharmaceutical ingredient",
      "Controlled release formulation",
      "Excipient compatibility",
      "Sustained release tablet",
      "Osmotic drug delivery",
      "Transdermal patch",
      "Extended-release capsule",
      "Pharmacogenomics",
      "Liposome encapsulation",
      "Monoclonal antibody therapy",
      "Recombinant dna technology",
      "Peptide drug conjugate",
      "High-performance liquid chromatography",
      "Clinical pharmacology",
      "Antisense oligonucleotide",
      "In-silico drug design",
      "Toxicokinetics",
      "Dissolution profile",
      "First-in-human trial",
    ],
    "zh-Hans": [
      "生物药剂学",
      "药代动力学",
      "脂溶性",
      "赋形剂",
      "前药",
      "生物利用度",
      "微粒酶",
      "手性",
      "对映体",
      "治疗指数",
      "半衰期消除",
      "首过代谢",
      "变构调节",
      "配体结合亲和力",
      "受体激动剂",
      "药效学",
      "孤儿药指定",
      "窄治疗指数",
      "生物转化",
      "肠溶包衣",
      "纳米载体",
      "多重用药",
      "药物警戒",
      "细胞毒剂",
      "配制药物",
      "药品主文件",
      "口服生物利用度",
      "腺苷三磷酸结合盒",
      "外排转运蛋白",
      "肠胃外给药",
      "无菌过滤",
      "亲水-疏水平衡",
      "活性药物成分",
      "控释配方",
      "赋形剂相容性",
      "缓释片",
      "渗透性药物递送",
      "透皮贴片",
      "延释胶囊",
      "药物基因组学",
      "脂质体包封",
      "单克隆抗体疗法",
      "重组DNA技术",
      "肽类药物偶联",
      "高效液相色谱",
      "临床药理学",
      "反义寡核苷酸",
      "计算机辅助药物设计",
      "毒代动力学",
      "溶出曲线",
      "首次人体试验",
    ],
  },
];

const TryDomainTranslation = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selected = useMemo(() => {
    return domains[selectedIndex];
  }, [selectedIndex]);

  const [hovered, setHovered] = useState<number | undefined>();

  return (
    <div className={classNames.TryDomainTranslation}>
      <div>
        {domains.map((d, i) => (
          <h3
            key={i}
            onClick={() => setSelectedIndex(i)}
            aria-selected={i === selectedIndex}
          >
            {d.name}
          </h3>
        ))}
      </div>
      <div>
        <div className={classNames.Translations}>
          <h3>🇺🇸 English</h3>
          <div>
            {selected["en"].slice(0, 30).map((t, i) => (
              <div
                key={t}
                onMouseEnter={() => setHovered(i)}
                onClick={() => setHovered(i)}
                data-active={i === hovered}
                className={classNames.Term}
              >
                <h3>{t}</h3>
              </div>
            ))}
          </div>
        </div>
        <div className={classNames.Translations}>
          <h3>🇨🇳 中文</h3>
          <div>
            {selected["zh-Hans"].slice(0, 30).map((t, i) => (
              <div
                key={t}
                onMouseEnter={() => setHovered(i)}
                onClick={() => setHovered(i)}
                data-active={i === hovered}
                className={classNames.Term}
              >
                <h3>{t}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TryDomainTranslation;
